import React, { useState, useEffect, useRef } from 'react';
import { Stack, TableBody } from '@mui/material';
import axios from 'axios';

import { AddButton } from '../../components/common/button/CustomButtons';
import ChildHeader from '../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../assets/styles/layout/searchFilter.styled';
import { SearchBar } from '../../components/common/SearchBar';
import { CustomPagination, TableCustom } from '../../components/common';
import useDebounce from '../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../components/common/Modal';
import { useQuery } from '../../hooks/UseQuery';
import useConfirm from '../../components/common/useConfirm';
import CustomUploadButton from '../../components/common/button/CustomUploadButton';
import ViewFile from './components/ViewFile';
import { StyledTableRow, StyledTableCell } from './helpers/module.styled';
import { useParams } from 'react-router-dom';
import PartDetailsHeader from '../../components/ui/PartDeatailsHeader';

const style1 = {
  backgroundColor: '#4F81BD',
  // backgroundColor: '#00B050',
  color: '#fff',
  minWidth: '80px',
  border: '1px solid #343a40',
};
const tableHeaderObj = [
  [
    { text: 'S.NO.', style: { ...style1 } },
    { text: 'DOCUMENT NAME', style: { ...style1 } },
    { text: 'REVISION NO.', style: { ...style1 } },
    { text: 'UPLOAD FILE', style: { ...style1 } },
    {
      text: 'Action',
      style: { ...style1, color: '#fff', backgroundColor: '#c92a2a' },
    },
  ],
];
const List = () => {
  const [data, setData] = useState<any[]>([]);
  const [isOpenCreate, setIsOpenCreate] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [listId, setListId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const search = useQuery('search') || '';
  const page = useQuery('page') || 1;

  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const documentType = useQuery('documentType');
  const heading = useQuery('heading');
  const idRef = useRef('');
  const { partID } = useParams<{ partID: string }>();  
  const partName = useQuery('part_name');
  const partNumber = useQuery('part_number');

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this?'
  );

  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/ppsListRoute?documentType=${documentType}&page=${page}&search=${search}&perPage=${perPage}&partID=${partID}`
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.result);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  useDebounce(fetchData, 500, [
    page,
    search,
    render,
    isOpenCreate,
    isOpenPopup,
  ]);

  const handleDelete = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/ppsListRoute/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  const uploadFile = async (e: any, id: string) => {
    if (!window.confirm('Are you sure you want upload this Files')) return;
    const files = e.target.files;
    if (!files) return;
    let formData = new FormData();
    for (const key of Object.keys(files)) {
      formData.append('files', files[key]);
    }
    setIsLoading(true);
    axios
      .patch(`/api/ppsListRoute/uploadFile/${id}`, formData)
      .then((res) => {
        if (res.data) {
          alert('document upload successly');
          setIsLoading(false);
          setRender((prev) => !prev);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      <ChildHeader text={`${heading} LIST`}>
        <AddButton
          onClick={() => setIsOpenCreate(true)}
          label={`NEW ${heading}`}
        />
      </ChildHeader>
      <PartDetailsHeader
        partName={partName || ''}
        partNumber={partNumber || ''}
      />
      <SearchFilterContainer filter={true} style={{width:'100%'}}>
        <SearchBar label="Search" />
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: any, index: number) => (
              <React.Fragment key={item._id}>
                <StyledTableRow index={index}>
                  <StyledTableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{ textTransform: 'capitalize' }}
                  >
                    {item?.document_name}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{ textTransform: 'capitalize' }}
                  >
                    {item?.revision_no}
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack
                      direction={'row'}
                      alignItems="center"
                      justifyContent="center"
                    >
                      {(item.files?.length === 0 )&&(
                        <CustomUploadButton
                          id={`upload-vendor-documents-${index}`}
                          accept="image/png,image/jpeg,image/jpg,application/pdf,.xlsx,.xls"
                          multiple={true}
                          onChange={(e) => {
                            uploadFile(e, item?._id || '');
                          }}
                        />
                      )}
                      
                      {item.files?.length > 0 && (
                        <>
                          <ViewIconButton
                            tooltipTitle="view"
                            sx={{ marginLeft: '1.5rem' }}
                            onClick={() => {
                              idRef.current = item._id || '';
                              setIsOpenPopup(true);
                            }}
                          />
                        </>
                      )}
                    </Stack>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setListId(item?._id || '');
                          setIsOpenCreate(true);
                        }}
                      />

                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          handleDelete(item?._id || '');
                        }}
                      />
                    </Stack>
                  </StyledTableCell>
                </StyledTableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        title="FILE LIST"
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
        }}
      >
        <ViewFile id={idRef.current} />
      </ModalCustom>
      <ModalCustom
        openModal={isOpenCreate}
        closeModal={() => {
          setListId(null);
          setIsOpenCreate(false);
        }}
        title={`CREATE ${heading}`}
      >
        <Create
          id={listId}
          setIsOpenCreate={setIsOpenCreate}
          setListId={setListId}
          partID={partID || ''}
        />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
